// Matches the GetCarousels CarouselID values. The single request returns every
// carousel; response entries are matched to rows by this id.
export const CAROUSEL_ID = {
  PILATE: 1,
  GYM: 2,
  BODY_AND_MIND: 3,
  MEN_ONLY: 4,
  WOMEN_ONLY: 5,
  RECENT_VISITS: 6,
};

// `key` identifies the row in the fetch state, so the enum names above never
// leak into state.
const carousel = (id, extra) => ({ id, key: String(id), ...extra });

// The home carousels, in display order — fixed here, NOT response order. Recent
// visits leads the feed and hides itself when there's nothing to show.
//
// Titles come from the response's CarouselName — copy is owned by the backend.
export const HOME_CAROUSELS = [
  // showPrice: the recent-visits row lists places the user has already been,
  // so a price tag on it is noise.
  carousel(CAROUSEL_ID.RECENT_VISITS, { showPrice: false }),
  carousel(CAROUSEL_ID.PILATE),
  carousel(CAROUSEL_ID.BODY_AND_MIND),
  carousel(CAROUSEL_ID.GYM),
  carousel(CAROUSEL_ID.WOMEN_ONLY),
  carousel(CAROUSEL_ID.MEN_ONLY),
];
